// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8418 ? "ac6cefa6" : chunkId) + "." + {"2779":"f606eda4d408cec7","5358":"0c3d34b0a63ed32d","5653":"c74731a24a8b229a","8418":"65cd71b4afa88b1c"}[chunkId] + ".js";
};